import React, { useState } from 'react'
import DynamicCard from '../../../../../CustomComponents/DynamicHomeCard'
import { width } from "../../../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles";
import Loader from '../../../../../CustomComponents/Loader/index.js'
import { useTranslation } from 'react-i18next'
import ConfirmationModuleSubItem from './ConfirmationModuleSubItem/index.js'
import Accept from "../../../../../../assets/images/Checkbox-blue.png"
import klogoGreen from "../../../../../../assets/images/LogokLogoGreen.png"
import PrimaryCard from "../../../../../../assets/smi-kudzu-images/smi_card_img.png"
// import NotAccept from "../../../../../../assets/images/Checkbox-light.png"
import { dateComparison, displayKudzuplusErrorMessage, retrieveData } from '../../../../../../utils/index.js'
import { GetApiHeadersWithBearer, PostRequest } from '../../../../../../network/NetworkUtils.js'
import { STATUS_SUCCESS_CODE, TRANSFER_FUNDS } from '../../../../../../network/URLConstants.js'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { displayErrorMessage } from '../../../../../../utils/index.js';
import moment from 'moment';
import logFirebaseEvents from '../../../../../LogFirebaseEvents/index.js';
import { ACH, appTheme } from '../../../../../../helpers/utils/Utils.js';
import { resolveAccountLogo, getAchDisclaimerType } from '../../../../../../helpers/utils/TransferMoneyUtils.js';
import ACHTransferLegalDisclaimer from './ACHTransferLegalDisclaimer/index.js';
import { selectIsTransferMoneyFeatureEnabled } from '../../../../../../Redux/selectors.js';
import CardHeading from '../../../../../CustomComponents/CardHeading/index.js';



const TransferMoneyConfirm = (props) => {
    const { datas, transferFundPayload, onSetStatus, onSetErrorMsg, onCancelSelect, onSetTransactionId } = props
    const { t } = useTranslation();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const [isAccept, setIsAccept] = useState(false);
    const [accpetErrorMessage, setAccpetErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const location = useLocation();
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
    const SMITransferMoneyPath = location.pathname.toLowerCase() == "/accountservices/smionecard/transfermoney";
   
    const getAccountLogo = (account) =>
        resolveAccountLogo(account, { klogoGreen, primaryCard: PrimaryCard, fallback: appThemeData.FPO });
    const accessToken = useSelector(state => state.accessToken);
    const cards = useSelector(state => JSON.parse(state.userCards));

    const fromAccountValue = datas?.[8]?.value;
    const toAccountValue = datas?.[9]?.value;

    const achDisclaimerType = getAchDisclaimerType(
        fromAccountValue,
        toAccountValue,
        transferFundPayload?.Frequency
    );

    const transferFund = async () => {
        try {
            setIsLoading(true);
            
            const deviceId = await retrieveData('updatedDeviceId')
            const cardKey = cards !== null ? cards[0].CardKey : 0;

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const url = TRANSFER_FUNDS.replace('{CARD_KEY}', cardKey)
            const body = transferFundPayload;
            const response = await PostRequest(url, body, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                console.log(responseJson, "responseJson of transfermoney++++++++++++++")
                const ACHTransactionId = responseJson.Response.ACHTransactionId
                const TransactionId = responseJson.Response.TransactionId
                const setTransactionIdObj = ACHTransactionId ? { "achTransactionId": ACHTransactionId } : TransactionId ? { "internalTransactionId": TransactionId } : {}
                if (responseJson?.Response?.ScheduleTransactionId) { setTransactionIdObj.scheduleTransactionId = responseJson?.Response?.ScheduleTransactionId }

                onSetTransactionId(setTransactionIdObj);
                props?.setScheduledTransactionId(transferFundPayload, responseJson.Response)
                if (transferFundPayload.TransferDate == moment().format('YYYY-MM-DD')) {
                    const fromBalance = responseJson.Response.FromAccountBalance;
                    const toBalance = responseJson.Response.ToAccountBalance;
                    if (transferFundPayload.IsScheduledTransfer === false) updateUserCardBalance(fromBalance, toBalance , SMITransferMoneyPath)

                }
                modalLogic(transferFundPayload?.IsScheduledTransfer);
                setIsLoading(false);
                dispatch({ type: "RESET_TRANSFER_PAYLOAD" })
                dispatch({ type: 'SUCCESSFUL_TRANSFER_RESPONSE', payload: { successfulTransferResponse: responseJson } });

            } else if (responseJson.Messages) {
                // alert(datas[8].value.AccountType);
                setIsLoading(false);
                const isChecking = ["Checking", "Spending"].includes(fromAccountValue.AccountType);
                const displayErrorText = responseJson.Messages[0].DisplayText;
                onSetErrorMsg(displayErrorText, isChecking == true ? 'Spending' : 'Savings');
                onSetStatus("error", isChecking == true ? 'Spending' : 'Savings');
                dispatch({ type: "RESET_TRANSFER_PAYLOAD" })
            }

        } catch (error) {
        }
    }

    const updateUserCardBalance = (fromBalance, toBalance , smiCard) => {
        const isFromInternal = fromAccountValue.ACHAccountInternalId === 0
        const isToInternal = toAccountValue.ACHAccountInternalId === 0
    
        if(smiCard){
             const updatedCardData = [...cards]; // Create a copy of the array
        updatedCardData.find(x => x.AccountTypeBit63 === 1).Balance = fromBalance; 
        updatedCardData.find(x => x.AccountTypeBit63 === 64).Balance = toBalance; 

        dispatch({ type: 'UPDATE_USER_CARDS', payload: { userCards: JSON.stringify(updatedCardData) } });


        dispatch({ type: 'SUCCESSFUL_TRANSFER_RESPONSE', payload: { successfulTransferResponse: null } });
        } else{
         
        //checking / saving
        if (isFromInternal) {
            const isChecking = ["Checking", "Spending"].includes(fromAccountValue.AccountType);
            const updatedCardData = [...cards]; // Create a copy of the array
            if (isChecking) {
                updatedCardData[0].Balance = fromBalance; // Update the Balance property of the checking object
            }
            else {
                updatedCardData[1].Balance = fromBalance; // Update the Balance property of the saving object
            }
            dispatch({ type: 'UPDATE_USER_CARDS', payload: { userCards: JSON.stringify(updatedCardData) } });
        }
        //checking / saving
        if (isToInternal) {
            //  const isChecking = datas[9].value.AccountType === "Checking"
            const isChecking = ["Checking", "Spending"].includes(toAccountValue.AccountType);
            const updatedCardData = [...cards]; // Create a copy of the array
            if (isChecking) {
                updatedCardData[0].Balance = toBalance; // Update the Balance property of the checking object
            }
            else {
                updatedCardData[1].Balance = toBalance; // Update the Balance property of the saving object
            }
            dispatch({ type: 'UPDATE_USER_CARDS', payload: { userCards: JSON.stringify(updatedCardData) } });

        }

        }

    }

    const handleConfirm = () => {
        logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Confirm_Clicked", "Confirm_Clicked", "", "");
        if (!isAccept) {
            setAccpetErrorMessage(t('please_select_authorization'));
            return;
        }
        transferFund();
    }

    const modalLogic = (isScheduleTransfer) => {
        const isChecking = ["Checking", "Spending"].includes(fromAccountValue.AccountType);
        var transferDateStatus = dateComparison(datas[6].value)
        if (transferFundPayload.Frequency == 'Recurring' || transferFundPayload.Frequency == 'RC') {
            transferDateStatus = "Future"
        }
        // const isInternal = datas[8].value.ACHAccountInternalId === 0    
        if (transferDateStatus === "Today") {
            onSetStatus("success", isChecking == true ? 'Spending' : 'Savings')
        }
        else if ((transferDateStatus === "Future") || ((transferDateStatus === "Future" || transferDateStatus === "Today"))) {
            onSetStatus("scheduled", isChecking == true ? 'Spending' : 'Savings')
        }
    }





    const children = () => {
        return (

            <>

                <div className={`${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}  flex justify-center flex-col  sm:mx-0 mx-4`}></div>

                {isTransferMoneyFeatureEnabled ? (
                    <p className='mt-8 font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                         sm:text-[22px] text-[25px]
                     leading-[26px] sm:leading-[24px] 
                      md:leading-[36px] text-[var(--transferHeading-text)] sm:mx-0 mx-4'>{t("almost_there")}</p>
                ) : (
                        <p className='mt-4 font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                         sm:text-[22px] text-[25px]
                     leading-[26px] sm:leading-[24px] 
                      md:leading-[36px] text-[var(--transferHeading-text)] sm:mx-0 mx-4'>{t("transfer_confirm_subheading1")}</p>
                )}

               
                <p className='pb-6 font-serif-pro font-[400] lg:text-[26px]
                         md:text-[24px] sm:text-[22px] text-[25px] leading-[26px] 
                   sm:leading-[24px] md:leading-[36px] 
                     text-[var(--transferSubHeading-text)] sm:mx-0 mx-4'>{t("transfer_confirm_subheading2")}</p>


               

                {isTransferMoneyFeatureEnabled ? (
                    <div className='flex justify-center sm:mx-0 mx-4'>
                        <div className='sm:w-[80%] w-full'>


                            {datas &&
                                <>
                                    <div className='flex flex-col items-center pt-6 pb-8'>
                                        <p className={`font-hanken-grotesk uppercase text-[var(--confirm-row-title)]
                                        lg:text-[13px] md:text-[12px] sm:text-[12px] text-[12px]
                                        font-[600] tracking-[2px] ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{datas[2]?.title}</p>
                                        <p className='font-hanken-grotesk font-[700] text-[var(--transferSubHeading-text)]
                                        lg:text-[48px] md:text-[48px] sm:text-[34px] text-[34px]
                                        leading-[48px] pt-4'>
                                            {(() => {
                                                const [whole, decimal] = String(datas[2]?.value ?? '').split('.');
                                                return (
                                                    <>
                                                        {`$${whole}`}
                                                        {decimal !== undefined &&
                                                            <sup className='text-[30px] font-[400]'>{`.${decimal}`}</sup>
                                                        }
                                                    </>
                                                );
                                            })()}
                                        </p>
                                    </div>

                                    {(() => {
                                        const isRecurringTransfer = datas?.[3]?.value ? datas[3].value.toLowerCase().includes('recurring') : false;
                                        const rowIndices = isRecurringTransfer ? [0, 1, 3, 4, 7, 5] : [0, 1, 3, 4, 5];
                                        return rowIndices.map((index, arrIndex, arr) => {
                                            const data = datas[index];
                                            const isLast = arrIndex === arr.length - 1;
                                            const showLogo = index === 0 || index === 1;
                                            return data?.value ? (
                                                <div key={index} className={`flex justify-between items-center gap-1 py-5 ${isLast ? '' : `border-b ${kudzuPlusTrue ? 'border-[#4B70B980]' : 'border-[#DCDCD6]'}`}`}>
                                                    <p className={`font-hanken-grotesk uppercase text-[var(--confirm-row-title)]
                                                lg:text-[13px] md:text-[12px] sm:text-[12px] text-[13px]
                                                font-[600] tracking-[2px] ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{data.title}</p>
                                                    <div className='flex items-center gap-2'>
                                                        {showLogo &&
                                                            <img src={getAccountLogo(index === 0 ? fromAccountValue : toAccountValue)} alt='account-icon' className='w-4 h-4 object-contain shrink-0' />
                                                        }
                                                        <p className='font-hanken-grotesk text-[var(--transferSubHeading-text)]
                                                    lg:text-[16px] md:text-[15px] sm:text-[13px] text-[14px]
                                                    font-[500] text-right'>{data.value}</p>
                                                    </div>
                                                </div>
                                            ) : null;
                                        });
                                    })()}
                                </>
                            }
                            <ACHTransferLegalDisclaimer disclaimerType={achDisclaimerType} />

                            <p className='font-hanken-grotesk font-[400] text-[16px] leading-[20px] 
                                         sm:text-[12px] sm:leading-[18px] md:text-[16px] md:leading-[24px] 
                                        text-[var(--transferSubHeading-text)] pt-10'>{t("auth_confirmation")}</p>

                            <button type="button" aria-pressed={isAccept} onClick={() => {
                                setAccpetErrorMessage('')
                                setIsAccept(prev => !prev)
                                logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Accept_Authority_Clicked", "Accept_Authority_Clicked", "", "");
                            }
                            } className='flex items-center pt-2 pb-6 w-fit gap-2'>
                                <img src={isAccept ? Accept : appThemeData.NotAccept} alt="" />
                                <p className='font-hanken-grotesk font-[500] sm:font-[700] 
                            md:font-[500] text-[14px] leading-[20px] sm:text-[12px]
                             sm:leading-[20px] md:text-[16px] md:leading-[24px] 
                             text-[var(--acceptAuth)]'>{t("accept_auth")}</p>

                            </button>
                            {accpetErrorMessage &&
                                <div className='mb-2'>
                                    {kudzuPlusTrue ? displayKudzuplusErrorMessage(accpetErrorMessage) : displayErrorMessage(accpetErrorMessage)}
                                </div>
                            }

                           

                            <div className=' hidden sm:flex sm:flex-col pb-20 pt-5'>
                                <button type="button" className="font-hanken-grotesk text-[16px] font-[500] sm:font-bold 
                            leading-[24px] sm:text-[12px] sm:leading-[12px] md:text-[16px] 
                            md:leading-[16px] bg-[#2965FB] text-white cursor-pointer 
                            border-2 px-2 py-4 border-[#2965FB] w-full"
                                    onClick={handleConfirm}>{t("confirm")}</button>

                                <button type="button" className='font-hanken-grotesk mt-3 text-[16px] font-[500] sm:font-bold 
                            leading-[24px] sm:text-[12px] sm:leading-[12px] md:text-[16px] 
                            md:leading-[16px]  text-[var(--cancelBtn-textColor)] cursor-pointer 
                            px-2 py-4  w-full'
                                    onClick={() => { onCancelSelect(false); logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Cancel_Clicked", "Cancel_Clicked", "", ""); }}>{t("cancel")}</button>
                            </div>

                            <div className='flex sm:hidden justify-between md:pb-20 sm:pb-10 pb-20  pt-10 gap-11 sm:mx-0 mx-4'>
                                <button type="button" className='font-hanken-grotesk flex items-center font-[600] md:font-[700] 
                         leading-[26px] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                          md:leading-[13px] 
                          lg:leading-[18px] text-secondary-2 cursor-pointer ' onClick={() => onCancelSelect(false)}>{t("cancel")}</button>
                                <button type="button" className=' font-hanken-grotesk font-[600]
                                     md:font-[700] leading-[26px] 
                                     lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                      md:leading-[13px]
                                      lg:leading-[18px] text-secondary-2 cursor-pointer 
                                      capitalize' onClick={handleConfirm}>{t("confirm")}</button>


                            </div>
                        </div>

                    </div>
                ) : (
                        <div className='flex justify-center sm:mx-0 mx-4'>
                            <div className='sm:w-[80%] w-full'>


                                {datas &&
                                    datas.slice(0, 6).map((data) => {
                                        return (
                                            <ConfirmationModuleSubItem data={data} />
                                        )
                                    })
                                }
                                <ACHTransferLegalDisclaimer disclaimerType={achDisclaimerType} />
                                <p className='font-hanken-grotesk font-[500]
                                         sm:font-[500] md:font-[700] text-[14px] leading-[20px] 
                                         sm:text-[12px] sm:leading-[18px] md:text-[16px] md:leading-[24px] 
                                        text-[var(--transferSubHeading-text)] pb-4 pt-10'>{t("auth_confirmation")}</p>

                                <button type="button" aria-pressed={isAccept} onClick={() => {
                                    setAccpetErrorMessage('')
                                    setIsAccept(prev => !prev)
                                    logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Accept_Authority_Clicked", "Accept_Authority_Clicked", "", "");
                                }
                                } className='flex items-center py-6 w-fit gap-2'>
                                    <img src={isAccept ? Accept : appThemeData.NotAccept} alt="" />
                                    <p className='font-hanken-grotesk font-[500] sm:font-[700] 
                            md:font-[500] text-[14px] leading-[20px] sm:text-[12px]
                             sm:leading-[20px] md:text-[16px] md:leading-[24px] 
                             text-[var(--editName)]'>{t("accept_auth")}</p>

                                </button>
                                {accpetErrorMessage &&
                                    <div className='mb-2'>
                                        {kudzuPlusTrue ? displayKudzuplusErrorMessage(accpetErrorMessage) : displayErrorMessage(accpetErrorMessage)}
                                    </div>
                                }

                               

                                <div className=' hidden sm:flex sm:flex-col pb-20 pt-5'>
                                    <button type="button" className="font-hanken-grotesk text-[16px] font-[500] sm:font-bold 
                            leading-[24px] sm:text-[12px] sm:leading-[12px] md:text-[16px] 
                            md:leading-[16px] bg-[#2965FB] text-white cursor-pointer 
                            border-2 px-2 py-4 border-[#2965FB] w-full"
                                        onClick={handleConfirm}>{t("confirm")}</button>

                                    <button type="button" className='font-hanken-grotesk mt-3 text-[16px] font-[500] sm:font-bold 
                            leading-[24px] sm:text-[12px] sm:leading-[12px] md:text-[16px] 
                            md:leading-[16px]  text-[var(--cancelBtn-textColor)] cursor-pointer 
                            px-2 py-4  w-full'
                                        onClick={() => { onCancelSelect(false); logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Cancel_Clicked", "Cancel_Clicked", "", ""); }}>{t("cancel")}</button>
                                </div>

                                <div className='flex sm:hidden justify-between md:pb-20 sm:pb-10 pb-20  pt-10 gap-11 sm:mx-0 mx-4'>
                                    <button type="button" className='font-hanken-grotesk flex items-center font-[600] md:font-[700] 
                         leading-[26px] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                          md:leading-[13px] 
                          lg:leading-[18px] text-secondary-2 cursor-pointer ' onClick={() => onCancelSelect(false)}>{t("cancel")}</button>
                                    <button type="button" className=' font-hanken-grotesk font-[600]
                                     md:font-[700] leading-[26px] 
                                     lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                      md:leading-[13px]
                                      lg:leading-[18px] text-secondary-2 cursor-pointer 
                                      capitalize' onClick={handleConfirm}>{t("confirm")}</button>


                                </div>
                            </div>

                        </div>
                )}

            </>
        )
    }

    return (
        <>

            <DynamicCard
                header={true}
                CardRadius={true}
                cardWidth={width.allpolicies}
                HeaderRadius={true}
                isWhite={appThemeData.isWhiteBgForCard}
                isDarkForKudzu={appThemeData.isDarkBgForCard}
                backgroundColor={'--cardHeading-bg'} 
                HeaderContent={
                    <>
                        <CardHeading heading={t('transfer_money')} />
                    </>
                }
            >
                {children()}
            </DynamicCard>

            {isLoading && <Loader />}
        </>
    )
}

export default withOidcSecure(TransferMoneyConfirm) 